import customTheme from '@/constants/theme.custom';
import { Box } from '@cmpsr/components';
import React from 'react';
import FooterFillSvg from './FooterFillSvg';

interface DoubleWaveProps {
  fillColor?: string;
  topWaveSrc?: string;
  topWaveTransform?: string;
}

/**
 * DoubleWave component with overlapping wave SVGs
 * The top wave is positioned above the bottom fill using z-index and transform
 */
const DoubleWave: React.FC<DoubleWaveProps> = ({
  fillColor = customTheme.colors.darkBlue,
  topWaveSrc = '/images/footer-ppra.svg',
  topWaveTransform = 'translateY(-35%)',
}) => {
  return (
    <Box position="relative" width="100%" height="100%">
      {/* Top wave image - positioned with transform for responsive scaling */}
      <img
        src={topWaveSrc}
        alt="Wave decoration"
        style={{
          width: '100%',
          height: 'auto',
          display: 'block',
          position: 'absolute',
          bottom: 0,
          left: 0,
          zIndex: 1,
          transform: topWaveTransform,
        }}
      />

      {/* Bottom fill SVG */}
      <Box position="absolute" bottom="0" left="0" width="100%" zIndex="0">
        <FooterFillSvg fill={fillColor} />
      </Box>
    </Box>
  );
};

export default DoubleWave;
